// components/tracker/preprint-label.tsx
//
// BE-BIXIV-1 S1 — THE preprint honesty marker. One component, one wording,
// for every surface that shows a preprint next to registry changes: the
// trial drawer timeline (S2), the company Activity tab (S3) and the email
// renderers that borrow its text (S4). Founder rule, 2026-08-24: every
// preprint item carries "Preprint, not peer reviewed", so a bioRxiv result
// can never read as a published finding.
//
// Styling is lifted from the Changes-page provenance mark
// (`.badgeChanges` in change-type-badge.module.css): Archivo 12px/16px,
// #17181b on #fff with the #e1e7ef hairline. No new colours, text at 12px,
// and #17181b on white is ~16:1 contrast. The values are inline rather than
// a new CSS module so this phase stays to its listed files and there is no
// equal-specificity override for a chunk-order race to lose.

import type { CSSProperties } from "react"

export const PREPRINT_LABEL_TEXT = "Preprint, not peer reviewed"

export const PREPRINT_LABEL_TIP =
  "Posted on a preprint server. It has not been peer reviewed and may change or be withdrawn."

const BASE_STYLE: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  boxSizing: "border-box",
  minHeight: 24,
  padding: "3px 8px",
  border: "1px solid #e1e7ef",
  borderRadius: 6,
  background: "#fff",
  color: "#17181b",
  fontFamily: '"Archivo", system-ui, sans-serif',
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 0,
  lineHeight: "16px",
  // Wraps like `.badgeChanges`: a nowrap chip overflows a narrow rail row.
  whiteSpace: "normal",
}

export function PreprintLabel({
  className,
  style,
}: {
  className?: string
  /** Layout-only overrides (margin, alignment). Never restate the colours. */
  style?: CSSProperties
}) {
  return (
    <span
      className={className}
      style={style ? { ...BASE_STYLE, ...style } : BASE_STYLE}
      title={PREPRINT_LABEL_TIP}
      data-preprint-label
    >
      {PREPRINT_LABEL_TEXT}
    </span>
  )
}
